import { render, staticRenderFns } from "./PageTemplateComponent.vue?vue&type=template&id=6001f5b4&"
import script from "./PageTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./PageTemplateComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports